import React from 'react';
import './Footer.css';

function Footer({ language }) {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>Maggie (Mengzhe) Wang</h3>
            <p>Premier real estate agent with a decade of experience helping clients achieve their property goals through personalized service and expert market knowledge.</p>
          </div>

          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#properties">Properties</a></li>
              <li><a href="#reviews">Reviews</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Services</h3>
            <ul>
              <li><a href="#">Home Buying</a></li>
              <li><a href="#">Home Selling</a></li>
              <li><a href="#">Investment Properties</a></li>
              <li><a href="#">Rental Properties</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact Info</h3>
            <ul>
              <li><i className="fas fa-phone"></i> +1 (780) 263-6320</li>
              <li><i className="fas fa-envelope"></i> maggiewang@vitahomes.ca</li>
              <li><i className="fas fa-map-marker-alt"></i> 11155 65 St NW, Edmonton, AB T5W 4K2, Canada</li>
            </ul>
          </div>
        </div>

        <div className="copyright">
          <p>&copy; 2025 Maggie Wang Real Estate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
